import styled from "styled-components";

import { ChipGroup } from "shared/ui/filters";
import { DateInput as BaseDateInput } from "shared/ui/inputs/DateInput";

/**
 * 게시 기간 입력 공용 컴포넌트.
 *
 * "게시 기간 설정" 칩으로 사용 여부를 토글하고, 사용 시에만 시작일/종료일을
 * 입력할 수 있다. 종료일은 시작일을 고르기 전까지 비활성된다.
 * 상태/규칙은 usePostingPeriod 훅이 담당하며 그 반환값을 그대로 넘겨 쓰면 된다.
 */
export function PostingPeriodField({
  enabled,
  onToggle,
  start,
  end,
  onStartChange,
  onEndChange,
  toggleLabel = "게시 기간 설정",
}) {
  return (
    <Field>
      <ToggleChip>
        <ChipGroup
          options={[{ label: toggleLabel, value: "on" }]}
          value={enabled ? "on" : null}
          onChange={(value) => onToggle(value === "on")}
        />
      </ToggleChip>
      <StyledDateInput
        type="date"
        value={start ?? ""}
        onChange={onStartChange}
        disabled={!enabled}
        $default={!start}
      />
      <Separator $disabled={!enabled}>~</Separator>
      <StyledDateInput
        type="date"
        value={end ?? ""}
        onChange={onEndChange}
        disabled={!enabled || !start}
        $default={!end}
      />
    </Field>
  );
}

const Field = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
`;

const ToggleChip = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 2px;
`;

const StyledDateInput = styled(BaseDateInput)`
  margin-right: 4px;
`;

const Separator = styled.span`
  color: ${({ $disabled }) => ($disabled ? "#cfd4d9" : "#000")};
`;

export default PostingPeriodField;
